<template>
  <div>
    <el-table
      border
      :data="dataTableValue"
      @sort-change="fn_tableSortChange"
      style="width: 100%"
      :max-height="heightTable"
      :default-sort="{prop: defaultSortValue[0], order: defaultSortValue[1]}"
    >
      <el-table-column label="Loại yêu cầu" width="180">
        <template slot-scope="scope">
          {{
            scope.row.type == 'DAY_OFF' ? 'Nghỉ làm' :
            scope.row.type == 'GO_LATE' ? 'Đi muộn' :
            scope.row.type == 'COME_BACK_SOON' ? 'Về sớm' :
            scope.row.type == 'WORK_EXPLANATION' ? 'Giải trình công' :
            scope.row.type == 'GO_OUT' ? 'Ra ngoài' :
            scope.row.type == 'GO_ON_BUSSINESS' ? 'Công tác' :
            scope.row.type == 'TIME_KEEPING_ONLINE' ? 'Chấm công online' :
            scope.row.type == 'WIFI_ATTENDANCE' ? 'Điểm danh thủ công' :
            scope.row.type == 'OT' ? 'Làm thêm giờ' : ''
          }}
        </template>
      </el-table-column>
      <el-table-column prop="content" label="Nội dung" />
      <el-table-column label="Thời gian" align="center" width="190" prop="created_at" sortable> 
        <template slot-scope="scope">
          {{ MethodService.formatDate(scope.row.created_at, 'datetime') }}
        </template>
      </el-table-column>
      <el-table-column 
        label="Trạng thái" 
        align="center" 
        width="210" 
        prop="status"
        :sortable="tabValue == 'Request'"
      >
        <template slot-scope="scope">
          <span
            :class="{
              'request-status': true,
              'watting-for-approval' : scope.row.status == 'WAITING_FOR_APPROVAL',
              'rejected' : scope.row.status == 'REJECTED',
              'approved' : scope.row.status == 'APPROVED',
            }"
          >
            {{
              scope.row.status == 'WAITING_FOR_APPROVAL' ? 'Đang chờ duyệt' :
              scope.row.status == 'REJECTED' ? 'Bị từ chối' :
              scope.row.status == 'APPROVED' ? 'Đã duyệt' : ''
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Hành động" align="center" width="120">
        <template slot-scope="scope">
          <el-button
            class="button-action detail"
            v-b-popover.hover.left="'Chi tiết'"
            @click="fn_handle('detail', scope.row.id)"
          >
            <i class="icon24-EyeOn"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import MethodService from "../../../../service/MethodService"

export default {
  props: {
    dataTable: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultSort: {
      type: Array,
      default: () => {
        return ['', '']
      }
    },
    sort: {
      type: String,
      default: ''
    },
    activeTab: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      MethodService,
      dataTableValue: [],
      defaultSortValue: this.defaultSort,
      tabValue: this.activeTab,
      heightTable: window.innerHeight - 290,
      sortValue: this.sort,
      renderToken: 0
    }
  },
  watch: {
    dataTable: {
      immediate: true,
      handler(newVal) {
        this.renderRowsIncrementally(newVal)
      }
    },
    defaultSort (newVal) {
      this.defaultSortValue = newVal
    },
    activeTab (newVal) {
      this.tabValue = newVal
    }
  },
  methods: {
    fn_handle(type, rowId) {
      this.$emit('handleClick', {
        type: type,
        rowId: rowId
      })
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.sortValue = column.prop;
      } else if (column.order == "descending") {
        this.sortValue = "-" + column.prop;
      } else {
        this.sortValue = "";
      }
      this.$emit('tableSortChange', {
        sort: this.sortValue
      })
    },
    async renderRowsIncrementally(rows) {
      const renderToken = ++this.renderToken
      const normalizedRows = Array.isArray(rows) ? rows : []
      const chunkSize = normalizedRows.length > 60 ? 30 : 15

      this.dataTableValue = []

      for (let index = 0; index < normalizedRows.length; index += chunkSize) {
        if (renderToken !== this.renderToken) {
          return
        }

        this.dataTableValue = this.dataTableValue.concat(
          normalizedRows.slice(index, index + chunkSize)
        )

        if (index + chunkSize < normalizedRows.length) {
          await new Promise((resolve) => {
            window.requestAnimationFrame(() => resolve())
          })
        }
      }
    }
  },
  beforeDestroy() {
    this.renderToken += 1
  }
}
</script>
<style lang="scss" scoped>

::v-deep .el-table {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: none;
  thead {
    tr {
      th {
        background: #FFFFFF !important;
        color: #444242;
      }
      &:first-child {
        th {
          background: #4F8AAB !important;
          color: #FFFFFF;
        }
      }
    }
  }
}
.request-status {
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
  &.watting-for-approval {
    color: #FFA800;
  }
  &.rejected {
    color: #F12727;
  }
  &.approved {
    color: #4F8AAB;
  }
}
.button-action {
  width: 22px;
  border: none;
  padding: 0;
  background: transparent;
  &.detail {
    color: #1E3CD7;
    &:hover {
      color: #1E3CD7;
    }
  }
}
</style>
